<script lang="ts">
  import { Col, Image } from "sveltestrap";
  import Card from "../../Core/Card.svelte";
  import browzer from "../../../Data/ComponentData/WidgetData/Genral/Browzerdata.json";
  let imgPath : string= '/assets/images/dashboard';
</script>

{#each browzer.browerdata as Browzer}
  <Col xl="4" sm="6" class={Browzer.class}>
    <Card cardProps="browser-widget">
      <div class="media" slot="contentbody">
        <div class="media-img">
          <Image src={`${imgPath}/${Browzer.src}`} alt="" />
        </div>
        <div class="media-body align-self-center">
          {#each Browzer.children as browzerItem}
            <div>
              <p>{browzerItem.time}</p>
              <h4><span class="counter">{browzerItem.count}</span>%</h4>
            </div>
          {/each}
        </div>
      </div>
    </Card>
  </Col>
{/each}
